<template>
  <div class="site">
    <Nav></Nav>
    <div class="actions">
      <!-- <Sound></Sound> -->
      <Action
        @make-action="toggleSoundscape"
        shape="sound"
        title="Earthbound 2072"
        subtitle="by AZL, Wadeful"
        :soundscapeLabel="soundscapeLabel"
      />
      <Action @make-action="toggleSubscribe" shape="email" title="Subscribe" />
    </div>
    <router-view v-slot="{ Component }">
      <transition :name="$store.state.pageTransition">
        <!-- :enter-active-class="enterClassName"
        :leave-active-class="leaveClassName" -->
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view>
    <div class="preload-images"></div>
  </div>
</template>

<script>
// Import components
import Nav from "./components/Nav.vue";
import Sound from "./components/Sound.vue";
import Action from "./components/Action.vue";

// Import global styles
import "./assets/variables.css";

export default {
  name: "Site",
  components: {
    Nav,
    Sound,
    Action,
  },
  data() {
    return {
      someValue: "heyo",
    };
  },
  computed: {
    soundscapeLabel() {
      return this.$store.state.soundscapeMuted ? "OFF" : "ON";
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch("setupSounds");

    setTimeout(() => {
      let activePath = this.$route.path.replace("/", "");
      if (activePath != "") {
        this.$store.dispatch("playSoundscape");
      }
    }, 200);
  },
  methods: {
    toggleSubscribe() {
      let page = "/subscribe";
      if (this.$route.path == page && this.$store.state.previousPage != null) {
        page = this.$store.state.previousPage;
      }

      this.$store.dispatch("prepareToNavigate", {
        from: this.$route.path,
        to: page,
        position: window.scrollY,
      });
      this.$router.push(page);

      this.$store.dispatch("playBell");
    },
    toggleSoundscape() {
      this.$store.dispatch("toggleSoundscape");
    },
  },
};
</script>

<style>
body,
html {
  background: var(--tan-01);
  height: 100%;
  width: 100%;
  margin: 0;
  color: var(--black);
  font-family: "Scala";
  font-weight: normal;
  font-style: normal;
  font-size: 10px;
}

#app {
  height: 100%;
  width: 100%;
}

.site {
  height: 100%;
  width: 100%;
  position: relative;
}

.page-container {
  position: absolute;
  height: 100%;
  width: 100vw;
  transform-origin: top center;
}

.page-container .page {
  position: relative;
  height: 100%;
  width: 100%;
}

/* .page h1 {
  width: 100%;
  text-align: center;
  margin: 80px 0;
} */

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.content .section {
  width: 485px;
  max-width: calc(100vw - 40px);
  margin-top: 80px;
}

.content .section:nth-child(1) {
  margin-top: 0;
}

.content .section video {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.actions {
  position: absolute;
  top: calc(24px - 8px);
  left: calc(24px - 8px);
  z-index: 10000;
  display: flex;
  flex-direction: column;
}

.preload-images::after {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  z-index: -1;
  content: url("/figures/theory/cc-placesetting.png");
}

@media (max-width: 655px) {
  body,
  html {
    font-size: 6px;
  }

  ul,
  p {
    font-size: 2.9rem;
  }

  h4 {
    font-size: 3.1rem;
  }

  .page .title-container {
    margin-top: 180px;
    margin-bottom: 120px;
  }

  .page .title-container h3 {
    font-size: 2.2rem;
  }
}
</style>